import { formatEcgBookmarks } from '@/shared/lib/aiUtils';
import { createClient } from '@/shared/api';
import LIST_ECG_BOOKMARKS_QUERY from '@/entities/bookmark/api/queries/listEcgBookmarks';
import type { IEcgBookmark } from '@/shared/model';
import type {
  ListEcgBookmarksQuery,
  ListEcgBookmarksQueryVariables,
} from '@/shared/api/generated/graphql';

export type ListEcgBookmarksResult = {
  isSuccess: boolean;
  message: string;
  ecgBookmarks: IEcgBookmark[];
};

// TODO(ts): typed as the ListEcgBookmarksFilter GraphQL input once its server-side shape is documented
/**
 * Loads the ECG bookmarks recorded on a study. Runs the bookmark list query with the filter and limit, and on success reshapes the bookmarks into strip records, otherwise throwing the server message.
 *
 * @param filter - Server-side filter for the bookmarks.
 * @param limit - Maximum number of bookmarks to fetch; defaults to 10.
 * @returns A promise resolving to the formatted bookmark strip records.
 */
const fetchListEcgBookmarks = async (filter: any, limit = 10) => {
  const client = await createClient();
  const result = await client.query<ListEcgBookmarksQuery, ListEcgBookmarksQueryVariables>({
    query: LIST_ECG_BOOKMARKS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data } = result;
  const { listEcgBookmarks } = data;
  if (listEcgBookmarks.isSuccess) {
    return formatEcgBookmarks(listEcgBookmarks.ecgBookmarks);
  }
  throw new Error(listEcgBookmarks.message);
};

export default fetchListEcgBookmarks;
